// cronValidation — P-105: pure 6-field cron-expression-validator.
// Separerad från scheduledTriggerClient.ts så server-pure helpers
// (scheduledTriggerRuntime.ts) kan importera utan att dra in
// Supabase-client.
//
// Stödjer standard 6-field: sekund minut timme dag månad veckodag.
// Field-syntax: *, N, a-b, a,b,c, star/N, number/N.

export function validateCronExpression(expr: string): { ok: boolean; reason?: string } {
  if (typeof expr !== 'string') return { ok: false, reason: 'not-a-string' };
  const trimmed = expr.trim();
  if (!trimmed) return { ok: false, reason: 'empty' };
  const fields = trimmed.split(/\s+/);
  if (fields.length !== 6) {
    return { ok: false, reason: `expected 6 fields, got ${fields.length}` };
  }
  const fieldRe = /^(\*|\*\/\d+|\d+(?:-\d+)?(?:,\d+(?:-\d+)?)*(?:\/\d+)?)$/;
  for (let i = 0; i < fields.length; i++) {
    if (!fieldRe.test(fields[i])) {
      return { ok: false, reason: `invalid field[${i}]: "${fields[i]}"` };
    }
  }
  return { ok: true };
}
